import React from 'react';
import styled from 'styled-components';
import { mixins, fonts } from '@custom-components/css';
import withStyles from '@mui/styles/withStyles';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import MuiTable from '@mui/material/Table';
import MuiTablePagination from '@mui/material/TablePagination';
import { SVGIcon } from '../SVGIcon';

export const TableWrapper = styled.div`
  overflow-x: auto;
`;

export const StyledSVGIcon = styled(SVGIcon)`
  margin: ${mixins.pxToRem(7)} ${mixins.pxToRem(5)} 0 ${mixins.pxToRem(5)};
`;

export const StyledCell = styled(
  withStyles({
    root: {
      paddingRight: 10,
      paddingLeft: 10,
      letterSpacing: -0.4,
      border: 'none'
    },
    body: {
      fontFamily: fonts.fontRegular,
      fontSize: 16
    }
  })(MuiTableCell)
)`
  label {
    margin: 0;
  }
`;

const spreadWidthProp = ({ minTableWidth, children, ...rest }) => <MuiTable {...rest}>{children}</MuiTable>;

export const StyledTable = styled(spreadWidthProp)`
  min-width: ${({ minTableWidth }) => minTableWidth};
`;

export const StyledTableRow = styled(MuiTableRow)`
  background-color: ${({ theme, expanded }) => (expanded === 'false' ? 'white' : theme.lighterText)};
`;

export const UpperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 5px 15px;
  ${({ theme }) => `background-color: ${theme.lighterText}`};
`;

export const HeaderRow = styled(MuiTableRow)`
  border-bottom: ${({ sub }) => (sub ? 'none' : '1px solid')};
  border-color: ${({ theme }) => theme.lightText};
`;

export const StyledTablePagination = withStyles({
  root: {
    fontFamily: fonts.fontRegular
  },
  caption: {
    fontFamily: fonts.fontRegular
  }
})(MuiTablePagination);
